import { useEffect, useState } from "react";
import api from "@/lib/api";

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

function ProductLabel({ item, coefficient }) {
  const variants = (item.variants || []).filter((v) => v.variant_record_id);
  return (
    <div className="label" data-testid={`cart-label-${item.id}`}>
      <div className="label-header">
        <span className="label-item-no">{item.item_no || "-"}</span>
      </div>
      <div className="label-description">{item.description || "-"}</div>
      <table className="label-table">
        <thead>
          <tr>
            <th>Size</th>
            <th>Price</th>
            <th>Pcs/CTN</th>
            <th>Inventory</th>
          </tr>
        </thead>
        <tbody>
          {variants.map((v, i) => {
            const price = v.final_price != null ? v.final_price : (num(v.price) || 0) * coefficient;
            return (
              <tr key={i}>
                <td>{(v.size || "-").trim()}</td>
                <td>${Number(price).toFixed(2)}</td>
                <td>{v.packing_qty != null ? Math.round(v.packing_qty) : "-"}</td>
                <td>{num(v.inventory_qty) != null ? Math.round(num(v.inventory_qty)) : "-"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default function CartLabelsPrint() {
  const [items, setItems] = useState(null);
  const [coefficient, setCoefficient] = useState(1);

  useEffect(() => {
    api.get("/cart").then(({ data }) => {
      setItems(data.items || []);
      setCoefficient(data.coefficient || 1);
    });
  }, []);

  useEffect(() => {
    if (items && items.length > 0) {
      const t = setTimeout(() => window.print(), 600);
      return () => clearTimeout(t);
    }
  }, [items]);

  if (!items) return <div style={{ padding: 20, fontSize: 13 }}>Loading labels...</div>;
  if (items.length === 0) return <div style={{ padding: 20, fontSize: 13 }}>Cart is empty - nothing to print.</div>;

  return (
    <div data-testid="cart-labels-print-page">
      <style>{`
        @page { size: 85mm 40mm; margin: 0; }
        html, body { margin: 0; padding: 0; background: #fff; }
        .label {
          width: 85mm;
          height: 40mm;
          box-sizing: border-box;
          padding: 2.5mm 3mm;
          overflow: hidden;
          page-break-after: always;
          break-after: page;
          font-family: Arial, Helvetica, sans-serif;
          color: #000;
          display: flex;
          flex-direction: column;
        }
        .label-header { display: flex; align-items: baseline; justify-content: space-between; }
        .label-item-no { font-size: 11pt; font-weight: 700; letter-spacing: 0.02em; }
        .label-description {
          font-size: 6.5pt; line-height: 1.25; margin-top: 0.5mm;
          display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
        }
        .label-table { width: 100%; border-collapse: collapse; margin-top: 1mm; }
        .label-table th, .label-table td {
          font-size: 6.5pt; padding: 0.4mm 1mm; border: 0.2mm solid #000; text-align: center;
        }
        .label-table th { font-weight: 700; background: #eee; }
        @media screen {
          body { background: #e5e5e5; }
          .label { background: #fff; margin: 8px auto; border: 1px dashed #999; }
        }
      `}</style>
      {items.map((item) => (
        <ProductLabel key={item.id} item={item} coefficient={coefficient} />
      ))}
    </div>
  );
}
